/**
 * Pure helper for the embedded quiz-player's postMessage language signal.
 *
 * quiz-player emits `{ eventType: 'LANGUAGE_CHANGED', language: <localeCode> }`
 * when the language changes via the player's own selector AFTER launch (in-place
 * HotSwapping, no reload). This extracts the new locale so the game can follow it
 * and stay in sync with the embedded player. The caller normalises the raw code
 * (normalizeLocale) before using it. Mirrors leaderboard/first-to-flag's helper.
 */
export function languageFromEvent(data, currentLocale) {
	if (!data || data.eventType !== "LANGUAGE_CHANGED") return null
	const lang = typeof data.language === "string" ? data.language.trim() : ""
	if (!lang || lang === currentLocale) return null
	return lang
}
